var exports = {
  "s": "jumpWiggle__1Ljq59",
};

module.exports = exports;
